import { BaseService } from "@/core/services/BaseService";

class LoginHistoryService extends BaseService<any>{
  endpoint = '/login-history'
}

export default new LoginHistoryService();